import { BookChapterCampaignHeader } from '@models/book/BookChapterCampaignHeader'
import { Expose, Transform } from 'class-transformer'

export class MyWritingListType {
  @Expose() id: number

  @Expose() coverResizeImgPath: string

  @Expose() coverImgPath: string

  @Expose() title: string

  @Expose() bookType: string

  @Expose()
  @Transform(({ value, obj }) => {
    return obj.isVisible ? value.toUpperCase() : 'DRAFT'
  })
  status: string

  @Expose() likeCount: number

  @Expose() commentCount: number

  @Expose() viewCount: number

  @Expose() amountSpent: number

  @Expose() isVisible: boolean

  @Expose() isBanned: boolean

  @Expose() totalEbookSeries: number

  @Expose() publishedUntil: string | null

  @Expose({ name: 'bookChapterCampaignHeaderWriter' }) bookChapterCampaignHeader: BookChapterCampaignHeader
}
